import createIcon from '../../createIcon';

/**
 * @component @name DeviceHub
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTZMMTMgMTJWOC44MkMxNC4xNiA4LjQgMTUgNy4zIDE1IDZDMTUgNC4zNCAxMy42NiAzIDEyIDNDMTAuMzQgMyA5IDQuMzQgOSA2QzkgNy4zIDkuODQgOC40IDExIDguODJWMTJMNyAxNkgzVjIxSDhWMTcuOTVMMTIgMTMuNzVMMTYgMTcuOTVWMjFIMjFWMTZIMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeviceHub = createIcon('DeviceHub', [
  [
    'path',
    {
      d: 'M17 16L13 12V8.82C14.16 8.4 15 7.3 15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6C9 7.3 9.84 8.4 11 8.82V12L7 16H3V21H8V17.95L12 13.75L16 17.95V21H21V16H17Z',
      key: 'ptbfi5',
    },
  ],
]);

export default DeviceHub;
